export default __webpack_public_path__ + "static/media/Peajes.174dcec7.png";